module.exports = __webpack_public_path__ + "media/images/lb/857-6f1dea5059a6cd607c4e1d78c8cee458.svg";